import React, { useRef, useEffect, useState } from 'react'

const King = ({
  name,
  agegroup,
  party,
  sex,
  highlighted,
  hovered,
}: {
  name: string,
  agegroup: number,
  party: string,
  sex: string,
  highlighted: boolean,
  hovered: any,
}) => {

  return (
    <span
      className={`king`}
      onMouseEnter={() => {
        if(agegroup)
          hovered()
      }}
    >
      <span className={highlighted ? 'active' : ''}>
        {name}
        {agegroup || party ? ' (' : ''}
        {agegroup ? `${agegroup}` : ''}
        {agegroup && party ? ', ' : ''}
        {party ? party : ''}
        {agegroup || party ? ')' : ''}
      </span>
    </span>
  )  
}

export const Kings = ({ 
  data,
  highlighted,
  highlightedKingsChanged
  }: {
  data: any,
  highlighted: Array<number>,
  highlightedKingsChanged: any
}) => {

  return (
    <div className='kings'>
      {data.executives.filter(e => !e.vacant).map((e, i) => <King 
        {...e}
        highlighted = {highlighted.includes(e.id)}
        key = {i}
        hovered={() => highlightedKingsChanged([e.id])}
      />)}
    </div>
  )
  
}
